import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  FormattedDate, FormattedMessage, useIntl,
} from 'react-intl';
import CustomBtn from '../../../generic/CustomBtn';

const Menu = () => {
  const translate = useIntl();
  const history = useHistory();

  return (
    <div className="menu">
      <div className="menu__wrapper">
        <div className="menu__nav">
          <div className="menu__wrapper-btn">
            <CustomBtn
              label={translate.formatMessage({ id: 'menu.registerNewProject' })}
              customClass="btn__launch"
              iconClass="icon-tree"
              handleClick={() => {
                history.push('/create-project');
              }}
            />
          </div>
          <div className="menu__list">
            <NavLink activeClassName="active" className="menu__item" exact to="/">
              <i className="icon-menu-burger" />
              <div>{translate.formatMessage({ id: 'menu.my-projects' })}</div>
            </NavLink>
            <NavLink activeClassName="active" className="menu__item" to="/field-agents">
              <i className="icon-shield-check" />
              <div>{translate.formatMessage({ id: 'menu.field-agents-assignments' })}</div>
            </NavLink>
            <NavLink activeClassName="active" className="menu__item" to="/my-field-agents">
              <i className="icon-users" />
              <div>{translate.formatMessage({ id: 'menu.my-field-agents' })}</div>
            </NavLink>
            <NavLink activeClassName="active" className="menu__item" to="/settings">
              <i className="icon-settings" />
              <div>{translate.formatMessage({ id: 'menu.setting' })}</div>
            </NavLink>
          </div>
        </div>

        <div className="menu__copy">
          <div className="menu__copy">
            <FormattedMessage
              id="needHelp"
            />
            {' '}
            <a className="menu__help" href="mailto:support@openforestprotocol.org">support@openforestprotocol.org</a>
          </div>
          <FormattedMessage
            id="copyRight"
          />
          <FormattedDate
            value={Date.now()}
            year="numeric"
          />

        </div>

      </div>
    </div>
  );
};

export default Menu;
